import { useCallback, useRef, useState } from 'react';

export const useIntersectionObserver = <T>(onIntersection: () => void) => {
  const observer = useRef<any>();

  const [isObserved, setIsObserved] = useState(false);

  const elementRef = useCallback(
    (node: T) => {
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          if (!isObserved) {
            console.log('observed');

            onIntersection();

            setIsObserved(true);
          }
        }
      });

      if (node) observer.current.observe(node);
    },
    [isObserved]
  );

  return { elementRef };
};
